import { render, staticRenderFns } from "./notifyStats.vue?vue&type=template&id=0976bcb2&scoped=true&lang=pug"
import script from "./notifyStats.vue?vue&type=script&lang=js"
export * from "./notifyStats.vue?vue&type=script&lang=js"
import style0 from "./notifyStats.vue?vue&type=style&index=0&id=0976bcb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976bcb2",
  null
  
)

export default component.exports